import { GameTextUtil } from "@lib/js-slingo-fruttiboost-core/dist/game/utils/GameTextUtil";
import { GameScatterWinProperties } from "@lib/js-slingo-fruttiboost-core/dist/game/view/abstract/properties/GameScatterWinProperties";
import { Point } from "pixi.js";
export class ScatterWinLandscapeProperties extends GameScatterWinProperties {
    constructor() {
        super();
        this.position.set(973, 512);
        const text = [this.winProperties, this.bigWinProperties, this.epicWinProperties, this.megaWinProperties].map(x => x.text);
        text.forEach(x => {
            x.size = new Point(700, 400);
        });
        GameTextUtil.centerProperties(...text);
    }
}
//# sourceMappingURL=ScatterWinLandscapeProperties.js.map